import { Fetcher, LOCAL_STORAGE_LANG } from "./Fetcher";
import { Locales, LocaleCode } from "@/utils/LocaleUtils";
import { App } from "vue";

export class UserPreferencesService extends Fetcher {
  static INSTANCE = new UserPreferencesService();

  setUserPrefLocale(locale: string, app?: App): void {
    localStorage.setItem(LOCAL_STORAGE_LANG, locale);
    // @ts-expect-error pour compatibilité avec Vue2 ou Vue3+$i18n non typé
    if (app?.$i18n) (app as any).$i18n.locale = locale;
  }

  getUserPrefLocale(): LocaleCode {
    const browserLocale = window.navigator.language.substring(0, 2);
    const fromStorage = localStorage.getItem(LOCAL_STORAGE_LANG);

    if (fromStorage && Object.values(Locales).includes(fromStorage as LocaleCode)) {
      return fromStorage as LocaleCode;
    }
    if (Object.values(Locales).includes(browserLocale as LocaleCode)) {
      return browserLocale as LocaleCode;
    }
    return Locales.FRENCH;
  }
}
